import React from "react"
import AddViewContent from "../../../../../core/gd-ui/add-view/add-view-content"
import NewView_NewResourceCustomViewStructure
    from "../../../../../core/model2/custom-view/add-custom-view/structure-new-resource-custom-view"

type Props = {
    className?              : string

    menuParams             : {
        projectId           : ID
        showAdditionalViews : boolean // Stuped name. Show or hide Dashboard and portfolio
    }

    selectedGroupId         : ID    // default category for views

    hidePopover             : callback
}

// const debug = "NavigationMenuNewView"
const debug = false

export default function NavigationMenuAdd_PopoverNewView(props:Props) {

    const groupedItems  = NewView_NewResourceCustomViewStructure(props.menuParams.projectId)

    debug && console.log(debug, 'render', groupedItems)

    // clicks inside custom popover content are ignored by the parent's click-outside,
    // so the parent "Add" popover has to be closed explicitly
    const hidePopover = () => {
        props.hidePopover()
        gd.layout.popovers.closeAll()
    }

    return (
        <AddViewContent
            viewsStructure  = {groupedItems}
            selectedGroupId = {props.selectedGroupId}
            hidePopover     = {hidePopover}
        />
    )
}
